import { toast } from "react-toastify";
import { observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { IEmpresa, newEmpresa } from "../../model";
import { toast_error } from "../../utils";

export class _CaixaPostalStore {

    obs = observable({
        select_empresa: newEmpresa() as IEmpresa,
        data1: "" as string,
        data2: "" as string,
        tasks_caixa_postal: [] as any[],
        tasks_length: 0 as number,
        credito_usados: 0 as number,
        credito_contratado: 0 as number,
        qrcode: "" as string,
        pix_id: "" as string,
        loading: false as boolean,
        loading_solicitacao: false as boolean,
        loading_solicitacoes: false as boolean,
        open_mensagens: false as boolean,
        mensagens_pendentes: [] as any,
        open_empresas_mensagens: false as boolean,

    })

    async handleTasksPaged(paged: number, cnpj: string, data1: string, data2: string) {
        try {
            let data = {
                page: paged,
                limit: 15,
                cnpj: cnpj,
                data1: data1,
                data2: data2
            }

            let resp = await apiOperacao("caixa_postal").post("/caixa_postal/index", data);

            this.obs.tasks_caixa_postal = [];
            this.obs.tasks_length = 0

            this.obs.tasks_caixa_postal = resp.data.itens;
            this.obs.tasks_length = resp.data.total;

        } catch (ex) { }

        this.obs.loading_solicitacoes = false
    }

    async handleSolicitaAssuntos(params: any) {

        this.obs.loading_solicitacao = true

        try {
            let resp = await apiOperacao("caixa_postal").post("caixa_postal/task/assuntos", params);

            if (resp.data.erros.length == 0) {
                toast.success('Solicitação realizada com sucesso!', {});
                return []

            } else {
                toast.error("Infelizmente, não foi possível realizar a solicitação para algumas empresas.", {});
                return resp.data.erros
            }
        } catch (ex) {
            toast_error(ex, `Erro ao realizar Solicitação, tente novamente mais tarde.`);
            return []
        }

    }

    async handleSolicitaMensagens(params: any) {

        this.obs.loading_solicitacao = true

        try {
            let resp = await apiOperacao("caixa_postal").post("/caixa_postal/task/msg", params);

            if (resp.data.ok) {
                toast.success('Solicitação realizada com sucesso!', {});

                this.obs.open_mensagens = false

                this.handleTasksPaged(1, this.obs.select_empresa.cnpj, this.obs.data1, this.obs.data2)

            } else {
                toast.error(resp.data.erro, {});

            }
        } catch (ex) {
            toast_error(ex, `Erro ao realizar Solicitação, tente novamente mais tarde.`);

        }

        this.obs.loading_solicitacao = false

    }

    async handleConsultaCredito() {
        try {
            let resp = await apiOperacao("caixa_postal").get("/caixa_postal/free/credits");

            this.obs.credito_usados = resp.data.qtd_utilizada
            this.obs.credito_contratado = resp.data.qtd_contratada
        } catch (ex) {
            toast_error(ex, `Erro ao consultar Saldos, tente novamente mais tarde.`);
        }
    }

    async handleBuyQuantidade(quantidade: number) {
        this.obs.loading = true

        try {
            let params = {
                quantidade: quantidade
            }
            let resp = await apiOperacao("caixa_postal").post("/caixa_postal/buy/credits", params);

            if (resp.data.ok) {
                this.obs.qrcode = resp.data.qrcode
                this.obs.pix_id = resp.data.pix_id
                this.obs.loading = false
                return true
            } else {
                toast.error(resp.data.msg, {});
                this.obs.loading = false
                return false
            }
        } catch (ex) {
            toast_error(ex, `Erro ao processar Compra, tente novamente mais tarde.`);
            this.obs.loading = false
            return false
        }
    }

    async handleConsultaMensagens() {
        try {
            let resp = await apiOperacao("caixa_postal").get("/caixa_postal/index/msg");
            
            this.obs.mensagens_pendentes = []
            if(resp.status == 200){
                this.obs.mensagens_pendentes = resp.data
            }
            

        } catch (ex) {
            toast_error(ex, `Erro ao consultar Mensagens pendentes, tente novamente mais tarde.`);
        }
    }

  async handleSaveLog(row: any) {

    try {
      let params = {
        id: row.id,
        index: row.index,
        isn: row.isn
      }

      let resp = await apiOperacao("caixa_postal").post("/caixa_postal/task/msg/visualiza", params)

    } catch (ex) { }

  }


}

export const CaixaPostalStore = new _CaixaPostalStore();
